// extracted by mini-css-extract-plugin
module.exports = {"product_list":"ProductList_product_list__-Ev2n"};